export default [
    {
        path: '/common/credential',
        name: 'credential',
        component: () => import("../views/agreement/credential.vue")
    },
    {
        path: '/agreement/userAgreement',
        name: 'userAgreement',
        component: () => import("../views/agreement/userAgreement.vue")
    },
    {
        path: '/agreement/monthlyAgreement',
        name: 'monthlyAgreement',
        component: () => import("../views/agreement/monthlyAgreement.vue")
    },
    {
        path: '/agreement/xiaomiAgreement',
        name: 'monthlyAgreement',
        component: () => import("../views/agreement/xiaomiUserAgreement.vue")
    },
    {
        path: '/agreement/harmony/privacy',
        name: 'harmonyPrivacy',
        component: () => import("../views/agreement/harmonyPrivacy.vue")
    },
    {
        path: '/agreement/harmony/personal',
        name: 'harmonyPersonal',
        component: () => import("../views/agreement/personal.vue")
    },
    {
        path: '/agreement/harmony/third_party_sharing',
        name: 'harmony_third_party_sharing',
        component: () => import("../views/agreement/third_party_sharing.vue")
    }
]
